import React from 'react';
import { Loader } from 'semantic-ui-react';

export const MailStatusIcon: React.FC<{
    isMailIn?: boolean;
    isMailInLoading?: boolean;
    isMailInUnavailable?: boolean;
    size?: string;
}> = ({ isMailIn = false, isMailInLoading = false, isMailInUnavailable = false, size = '2rem' }) => (
    <div
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 50,
            height: 50,
        }}
        aria-label={
            isMailInLoading
                ? 'Loading mail status...'
                : isMailInUnavailable
                    ? 'Unable to load mail status.'
                    : isMailIn
                        ? 'The mail has arrived.'
                        : "The mail hasn't arrived yet today."
        }
    >
        {isMailInLoading ? (
            <Loader active inline size="small" style={{ margin: 0 }} />
        ) : (
            <i
                className="fa-solid fa-envelope"
                style={{
                    fontSize: size,
                    color: isMailInUnavailable ? '#8a8a8a' : isMailIn ? '#69B546' : '#ed3737',
                }}
                aria-hidden
            />
        )}
    </div>
);

export const HomeIcon: React.FC<{ width?: number; height?: number; style?: React.CSSProperties; }> = ({
    width = 100,
    height = 79,
    style = {},
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 79" fill="none" style={style}>
        <g filter="url(#filter0_d_56_42)">
            <path d="M48.3602 18.3858L19.1907 42.4103V68.3396C19.1907 69.011 19.4574 69.6549 19.9321 70.1296C20.4069 70.6043 21.0507 70.871 21.7221 70.871L39.4513 70.8251C40.1205 70.8218 40.7611 70.5536 41.2331 70.0792C41.7051 69.6049 41.9701 68.9629 41.97 68.2937V53.1513C41.97 52.4799 42.2367 51.836 42.7115 51.3613C43.1862 50.8866 43.8301 50.6199 44.5014 50.6199H54.627C55.2984 50.6199 55.9422 50.8866 56.417 51.3613C56.8917 51.836 57.1584 52.4799 57.1584 53.1513V68.2827C57.1573 68.6158 57.2221 68.9458 57.3488 69.2538C57.4755 69.5618 57.6618 69.8418 57.897 70.0777C58.1322 70.3136 58.4116 70.5008 58.7192 70.6285C59.0269 70.7562 59.3567 70.822 59.6898 70.822L77.4127 70.871C78.084 70.871 78.7279 70.6043 79.2026 70.1296C79.6774 69.6549 79.9441 69.011 79.9441 68.3396V42.3929L50.7809 18.3858C50.438 18.1094 50.0109 17.9587 49.5705 17.9587C49.1302 17.9587 48.7031 18.1094 48.3602 18.3858ZM94.4363 34.7148L81.2097 23.8125V1.89854C81.2097 1.39502 81.0097 0.912116 80.6537 0.556071C80.2976 0.200025 79.8147 0 79.3112 0H70.4513C69.9478 0 69.4649 0.200025 69.1089 0.556071C68.7528 0.912116 68.5528 1.39502 68.5528 1.89854V13.3863L54.3881 1.73242C53.0288 0.613829 51.323 0.00223608 49.5626 0.00223608C47.8022 0.00223608 46.0965 0.613829 44.7372 1.73242L4.68901 34.7148C4.49676 34.8737 4.33771 35.069 4.22094 35.2894C4.10416 35.5097 4.03196 35.751 4.00845 35.9993C3.98494 36.2476 4.01059 36.4981 4.08393 36.7365C4.15727 36.9749 4.27686 37.1965 4.43587 37.3886L8.47027 42.2932C8.62885 42.486 8.8239 42.6457 9.04426 42.763C9.26462 42.8804 9.50596 42.9531 9.75447 42.9771C10.003 43.001 10.2538 42.9757 10.4925 42.9026C10.7312 42.8295 10.9531 42.7101 11.1456 42.5511L48.3602 11.8991C48.7031 11.6228 49.1302 11.4721 49.5705 11.4721C50.0109 11.4721 50.438 11.6228 50.7809 11.8991L87.997 42.5511C88.1892 42.7101 88.4108 42.8297 88.6492 42.903C88.8876 42.9764 89.1381 43.002 89.3864 42.9785C89.6347 42.955 89.8759 42.8828 90.0963 42.766C90.3167 42.6492 90.5119 42.4902 90.6708 42.2979L94.7052 37.3934C94.8641 37.2001 94.9832 36.9774 95.0556 36.7379C95.1281 36.4985 95.1525 36.2471 95.1275 35.9982C95.1026 35.7493 95.0286 35.5078 94.91 35.2875C94.7914 35.0673 94.6304 34.8727 94.4363 34.7148Z" fill="#5A9BD5" />
        </g>
        <defs>
            <filter id="filter0_d_56_42" x="0" y="0" width="99.137" height="78.871" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_56_42" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_56_42" result="shape" />
            </filter>
        </defs>
    </svg>
);

export const MenuProfileIcon: React.FC<{ width?: number; height?: number; style?: React.CSSProperties; }> = ({
    width = 53,
    height = 60,
    style = {},
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 53 60"
        fill="none"
        style={{ background: 'transparent', ...style }}
    >
        <g clipPath="url(#clip0_menu_profile)">
            <path d="M26.5 30C30.5161 30 34.3678 28.4196 37.2076 25.6066C40.0475 22.7936 41.6429 18.9782 41.6429 15C41.6429 11.0218 40.0475 7.20644 37.2076 4.3934C34.3678 1.58035 30.5161 0 26.5 0C22.4839 0 18.6322 1.58035 15.7924 4.3934C12.9525 7.20644 11.3571 11.0218 11.3571 15C11.3571 18.9782 12.9525 22.7936 15.7924 25.6066C18.6322 28.4196 22.4839 30 26.5 30ZM21.0935 35.625C9.44063 35.625 0 44.9766 0 56.5195C0 58.4414 1.57344 60 3.51362 60H49.4864C51.4266 60 53 58.4414 53 56.5195C53 44.9766 43.5594 35.625 31.9065 35.625H21.0935Z" fill="#808284" />
        </g>
        <defs>
            <clipPath id="clip0_menu_profile">
                <rect width="53" height="60" />
            </clipPath>
        </defs>
    </svg>
);

export const DefaultSpeak2Logo: React.FC<{ style?: React.CSSProperties; }> = ({ style = {} }) => (
    <img
        src={`${process.env.PUBLIC_URL}/speak2logo.svg`}
        alt="Speak2 Family"
        style={{
            height: '85px',
            width: 'auto',
            ...style,
        }}
    />
);
